<template>
  <VCard flat>
    <VForm
      v-model="isFormValid"
      @submit.prevent="editAgency"
    >
      <VProgressLinear
        v-if="!currentAgency"
        height="2"
        indeterminate
      />
      <VCardText v-else>
        <VSubheader>{{ $t('main') }}</VSubheader>

        <VLayout
          wrap
          class="mx-4"
        >
          <VFlex xs12>
            <VTextField
              v-model="currentAgency.name"
              :error-messages="errorMessages.name"
              :disabled="!$can('edit', 'AllAgencies')"
              :label="$t('name') + '*'"
              :rules="[$rules.isRequired]"
              class="mx-2"
              required
            />
          </VFlex>
          <VTextField
            v-model="currentAgency.number"
            :error-messages="errorMessages.number"
            :disabled="!$can('edit', 'AllAgencies')"
            :label="$t('number') + '*'"
            :rules="[$rules.isRequired]"
            class="mx-2"
            required
          />
          <VTextField
            v-model="currentAgency.commission"
            :error-messages="errorMessages.commission"
            :disabled="!$can('edit', 'AllAgencies')"
            :label="$t('commission') + '*'"
            :rules="[$rules.isRequired]"
            class="mx-2"
            required
          />
        </VLayout>

        <VSubheader>{{ $t('contacts') }}</VSubheader>
        <VLayout
          wrap
          class="mx-4"
        >
          <VFlex xs12>
            <VTextField
              v-model="currentAgency.contact_person"
              :error-messages="errorMessages.contact_person"
              :label="$t('contact_person')"
              class="mx-2"
              required
            />
          </VFlex>
          <VTextField
            v-model="currentAgency.phone"
            :error-messages="errorMessages.phone"
            :label="$t('phone')"
            class="mx-2"
            required
          />
          <VTextField
            v-model="currentAgency.mobile_number"
            :error-messages="errorMessages.mobile_number"
            :label="$t('mobile_number')"
            class="mx-2"
            required
          />
        </VLayout>

        <VSubheader>{{ $t('address') }}</VSubheader>
        <VLayout
          wrap
          class="mx-4"
        >
          <VFlex xs12>
            <SelectCity
              :value="{zip: currentAgency.zip, city: currentAgency.city }"
              :error-messages="errorMessages.city || errorMessages.zip"
              class="mx-2"
              @input="({zip, name}) => Object.assign(currentAgency, {zip, city: name})"
            />
          </VFlex>
          <VTextField
            v-model="currentAgency.street"
            :error-messages="errorMessages.street"
            :label="$t('street')"
            class="mx-2"
            required
          />
        </VLayout>

        <VSubheader>{{ $t('bank') }}</VSubheader>
        <VLayout
          wrap
          class="mx-4"
        >
          <VFlex xs12>
            <VTextField
              v-model="currentAgency.bankname"
              :error-messages="errorMessages.bankname"
              :label="$t('bankname')"
              class="mx-2"
              required
            />
          </VFlex>

          <VTextField
            v-model="currentAgency.iban"
            :error-messages="errorMessages.iban"
            :label="$t('iban')"
            class="mx-2"
            required
          />
          <VTextField
            v-model="currentAgency.bic"
            :error-messages="errorMessages.bic"
            :label="$t('bic')"
            class="mx-2"
            required
          />
        </VLayout>
      </VCardText>

      <VCardActions>
        <VSpacer />

        <VBtn
          type="submit"
          color="primary"
          :loading="isLoading"
          :disabled="!isFormValid || isLoading || !currentAgency"
        >
          {{ $t('editAgency') }}
        </VBtn>
      </VCardActions>
    </VForm>
  </VCard>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectCity from '@/components/global-components/inputs/SelectCity'

export default {
  name: 'AgencyEdit',
  components: { SelectCity },
  props: {
    agencyId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isLoading: false,
      isFormValid: false,
      errorMessages: {}
    }
  },
  computed: {
    ...mapGetters('agency', ['currentAgency'])
  },
  methods: {
    ...mapActions('agency', ['saveAgency']),
    async editAgency () {
      if (!this.isFormValid) return

      // Remove empty items from request
      for (let item in this.currentAgency) {
        if (this.currentAgency[item] === '' || this.currentAgency[item] === null) delete this.currentAgency[item]
      }

      this.isLoading = true
      try {
        await this.$notification(this.saveAgency({ agency: this.currentAgency }))
      } catch (e) {
        this.errorMessages = e
      }
      this.isLoading = false
    }
  },
  watch: {
    currentAgency: {
      immediate: true,
      deep: true,
      handler () {
        this.errorMessages = {}
      }
    }
  },
  i18n: {
    messages: {
      de: {
        number: 'Agentur Nummer',
        name: 'Firmenname',
        commission: 'Provision',
        editAgency: 'Speichern',
        main: 'Basisdaten',
        contacts: 'Kontaktdaten',
        contact_person: 'Kontaktperson',
        phone: 'Telefon',
        mobile_number: 'Mobil',
        city: 'Stadt',
        street: 'Straße',
        zip: 'PLZ',
        address: 'Adresse',
        bank: 'Bank',
        bankname: 'Name der Bank',
        iban: 'IBAN',
        bic: 'BIC'
      },
      en: {
        number: 'Agency number',
        name: 'Company name',
        commission: 'Commissin',
        editAgency: 'Save',
        main: 'Base data',
        contacts: 'Contact data',
        contact_person: 'Contact person',
        phone: 'Phone',
        mobile_number: 'Mobile',
        city: 'Town',
        street: 'Street',
        zip: 'Zip',
        address: 'Address',
        bank: 'Bank',
        bankname: 'Bank name',
        iban: 'IBAN',
        bic: 'BIC'
      }
    }
  }
}
</script>
